// Think5WhysHelp.jsx
import React, { useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import '../../styles/Think5WhysHelp.css';

const AboutThink5WhysPlatform = () => {
  const topics = [
    {
      title: 'Think5Whys Introduction',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. About the Platform:</strong>
            The Learning module is your gateway to a wealth of knowledge. Access various resources, whitepapers,
            videos, and courses designed to enhance critical thinking skills using the Think5Whys framework.
            Elevate your understanding and application of this powerful methodology.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. About the founder:</strong>
            Sanjeev Kumar is the founder of Think5Whys concept.
          </p>
          <div>
            <p>
              Sanjeev Kumar is an experienced professional, writer passionate about research, product development, teaching, mentoring, technology solutions, and continuous process improvement. 
              With over 28 years of diverse experience in education, corporate roles, and entrepreneurship, 
              Sanjeev brings extensive knowledge and expertise to his work. His notable contribution 
              in the e-commerce industry has been as a solution architect, technical architect, business transformer, and other 
              key operational as well as analytical roles, including digital strategy and heading the e-commerce department.
            </p>

            <p>
              Having a Six Sigma Black Belt certification, Sanjeev showcases mastery in process improvement methodologies. 
              He holds an MCA degree, a B.Sc. in Mathematics (Honors), and pursued an MBA in Finance. This diverse educational background enables him to bridge theory and practice effectively.
            </p>

            <p>
              Sanjeev's career focuses on empowering through education and mentoring, guiding individuals effectively 
              with his simplified teaching style. In addition to teaching, Sanjeev has actively participated in entrepreneurship and 
              project management in corporate settings, providing practical insights in his writing.
            </p>

            <p>
              As an author, Sanjeev is committed to creating impactful and accessible content. His books inspire young minds, 
              stimulate critical thinking, and nurture a passion for lifelong learning. 
              His expertise in Six Sigma and talent for conveying complex concepts make his works valuable resources 
              for leaders, workers, researchers, students, educators, and professionals.
            </p>

            <p>
              His couple of upcoming creations, “Processifyd” is to provide a solution framework to 
              power youth and women lead startups across the globe, and "Purple Power," introduces Six Sigma to K12, aiming 
              to certify kids worldwide with the Six Sigma Purple Belt.
            </p>

            <p>
              Sanjeev's exceptional record and genuine drive continue to impact education and continuous improvement.
            </p>

            <p>
              Sanjeev's Social Profile: <a href="https://www.linkedin.com/in/sanjeevkumarmumbai" target="_blank" rel="noopener noreferrer">https://www.linkedin.com/in/sanjeevkumarmumbai</a>
            </p>

            <p>
              Emails to reach out: <a href="mailto:contact@processifyd.com">contact@processifyd.com</a>, <a href="mailto:think5whys@gmail.com">think5whys@gmail.com</a>, <a href="mailto:sanjeev@processifyd.com">sanjeev@processifyd.com</a>, <a href="mailto:sanjeevkumarmumbai@gmail.com">sanjeevkumarmumbai@gmail.com</a>
            </p>
          </div>
          <p>
            <strong style={{ color: 'black' }}>3. About the team:</strong><br/>
            <strong>Babita Sinha (Co-founder)</strong>
          </p>
        </div>
      ),
    },
    {
      title: 'Vision',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>"Vision: Empowering Every Mind, Transforming Every Space"</strong>
            At Think5Whys, our vision is to revolutionize the way individuals, homes, institutions, corporates, SMEs,
            and professionals engage with critical thinking, problem-solving, and personal development.
            We aspire to make Think5Whys a ubiquitous tool and platform, fostering a culture of deep analysis,
            insightful collaboration, and continuous growth in every corner of the world.
            Our commitment lies in empowering minds, enriching lives, and creating a global community
            where the power of critical thinking becomes an integral part of everyone's journey.
            Join us as we embark on a collective mission to elevate human potential, one thoughtful decision at a time.
          </p>
        </div>
      ),
    },
    {
      title: 'Mission',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>"Mission Statement: Transforming Lives, Shaping Futures with Think5Whys"</strong>
            At Think5Whys, our mission is to impact over 3 billion+ lives worldwide through our
            innovative and transformative approach in the realms of deep thinking and critical analysis.
            We are dedicated to enhancing the overall quality of individuals, homes, institutions, corporates,
            SMEs, and professionals by providing accessible, intuitive, and empowering tools and platforms.
            With a commitment to fostering a culture of continuous improvement and thoughtful decision-making,
            we strive to be the catalyst for positive change in every corner of the globe.
            Join us on our mission to elevate minds, inspire growth, and create a world where
            the power of deep thinking becomes the cornerstone of personal and professional success.
          </p>
        </div>
      ),
    },
    {
      title: 'Values',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. Innovation:</strong>
            Embrace and drive innovative solutions for deep thinking and critical analysis.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. Accessibility:</strong>
            Ensure Think5Whys is accessible to individuals, homes, institutions, corporates, SMEs, and professionals worldwide.
          </p>

          <p>
            <strong style={{ color: 'black' }}>3. Empowerment:</strong>
            Empower individuals to become critical thinkers and problem solvers in various aspects of life.
          </p>

          <p>
            <strong style={{ color: 'black' }}>4. Collaboration:</strong>
            Foster collaboration by providing a platform for sharing insights, experiences, and solutions.
          </p>

          <p>
            <strong style={{ color: 'black' }}>5. Continuous Improvement:</strong>
            Strive for continuous improvement in the quality of decision-making and problem-solving processes.
          </p>

          <p>
            <strong style={{ color: 'black' }}>6. Diversity and Inclusion:</strong>
            Celebrate diversity and promote an inclusive environment for a broad range of perspectives and experiences.
          </p>

          <p>
            <strong style={{ color: 'black' }}>7. Transparency:</strong>
            Operate with transparency in all interactions, ensuring users understand the methodology and purpose of Think5Whys.
          </p>

          <p>
            <strong style={{ color: 'black' }}>8. Ethical Practice:</strong>
            Uphold ethical standards in the use of data and information, prioritizing privacy and confidentiality.
          </p>

          <p>
            <strong style={{ color: 'black' }}>9. Global Impact:</strong>
            Aim for a global impact by reaching billions of lives and contributing to positive societal change.
          </p>

          <p>
            <strong style={{ color: 'black' }}>10. User-Centric Approach:</strong>
            Prioritize the needs and experiences of users, continuously adapting and enhancing Think5Whys based on feedback.
          </p>
        </div>
      ),
    },
    {
      title: 'Target Audience',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>Target Audience:</strong>
            Think5Whys is designed to engage a diverse audience, guiding individuals, professionals, and organizations towards deep thinking, critical analysis, and effective Root Cause Analysis. The platform caters to various user segments, aligning its content and features with the unique needs of each group.
          </p>

          <p>
            <strong style={{ color: 'black' }}>User Segments and Purposes:</strong>
          </p>

          <ol>
            <li>
              <strong style={{ color: 'black' }}>Students:</strong>
              <ul>
                <li><strong>Self-Management:</strong> Empowering students with tools for self-reflection and time management.</li>
                <li><strong>Study:</strong> Enhancing critical thinking skills to improve study methods.</li>
                <li><strong>Miscellaneous:</strong> Providing resources for fostering deep thinking across diverse student needs.</li>
              </ul>
            </li>

            <li>
              <strong style={{ color: 'black' }}>Parents:</strong>
              <ul>
                <li><strong>Parenting:</strong> Encouraging critical reflection on parenting strategies.</li>
                <li><strong>Children's Study:</strong> Guiding parents to support their children's study habits.</li>
                <li><strong>General:</strong> Offering insights and resources for critical thinking in general parenting scenarios.</li>
              </ul>
            </li>

            <li>
              <strong style={{ color: 'black' }}>Family:</strong>
              <ul>
                <li><strong>Family Topic:</strong> Promoting deep thinking on various family-related topics.</li>
                <li><strong>Miscellaneous:</strong> Providing resources for fostering critical discussions within families.</li>
              </ul>
            </li>

            <li>
              <strong style={{ color: 'black' }}>Education:</strong>
              <ul>
                <li><strong>Student:</strong> Facilitating critical thinking skills for students.</li>
                <li><strong>Teachers:</strong> Empowering educators with tools for effective teaching.</li>
                <li><strong>Institution:</strong> Encouraging deep analysis for institutional growth.</li>
                <li><strong>Miscellaneous:</strong> Offering additional resources for diverse educational purposes.</li>
              </ul>
            </li>

            <li>
              <strong style={{ color: 'black' }}>Job Seeker:</strong>
              <ul>
                <li><strong>Critical Thinking:</strong> Developing critical thinking skills for effective decision-making.</li>
                <li><strong>Interview Outcome:</strong> Guiding job seekers to analyze interview outcomes critically.</li>
              </ul>
            </li>

            <li>
              <strong style={{ color: 'black' }}>Individuals:</strong>
              <ul>
                <li><strong>Critical Thinking:</strong> Fostering a culture of deep thinking for personal development.</li>
                <li><strong>Self-Improvement:</strong> Providing tools for introspection and continuous self-improvement.</li>
                <li><strong>Hobby & Research:</strong> Encouraging critical analysis within personal interests.</li>
                <li><strong>Community:</strong> Promoting critical discussions within a community.</li>
                <li><strong>General:</strong> Offering resources for general critical thinking.</li>
              </ul>
            </li>

            <li>
              <strong style={{ color: 'black' }}>Professionals:</strong>
              <ul>
                <li><strong>Client:</strong> Guiding professionals in critical client interactions.</li>
                <li><strong>Self Learning:</strong> Encouraging a culture of continuous learning and critical reflection.</li>
              </ul>
            </li>

            <li>
              <strong style={{ color: 'black' }}>Business Persons:</strong>
              <ul>
                <li><strong>Business Issues:</strong> Facilitating Root Cause Analysis for effective problem-solving.</li>
                <li><strong>Work-Life Balance:</strong> Providing tools for critical analysis to maintain a healthy work-life balance.</li>
              </ul>
            </li>

            <li>
              <strong style={{ color: 'black' }}>Corporate:</strong>
              <ul>
                <li><strong>Self:</strong> Empowering individual employees with deep thinking tools.</li>
                <li><strong>Team:</strong> Promoting critical collaboration within teams.</li>
                <li><strong>Employee:</strong> Encouraging deep analysis for employee development.</li>
                <li><strong>Department, Branch, Functional Tasks:</strong> Providing resources for critical thinking in various corporate functions.</li>
                <li><strong>Organisation:</strong> Guiding organizations in deep analysis for overall development.</li>
                <li><strong>Miscellaneous:</strong> Offering additional resources for diverse corporate critical thinking needs.</li>
              </ul>
            </li>

            <li>
              <strong style={{ color: 'black' }}>Government:</strong>
              <ul>
                <li><strong>Administration, Policies:</strong> Encouraging deep thinking for effective governance.</li>
                <li><strong>Law & Order:</strong> Providing resources for critical analysis in legal matters.</li>
                <li><strong>Healthcare, Education:</strong> Facilitating deep analysis for sector-specific challenges.</li>
                <li><strong>Employees:</strong> Guiding government employees in critical decision-making.</li>
                <li><strong>Others:</strong> Offering miscellaneous resources for various government purposes.</li>
              </ul>
            </li>
          </ol>

          <p>
            This approach ensures that Think5Whys serves as a hub for cultivating deep thinking, critical analysis, and Root Cause Analysis across different domains, empowering users to navigate challenges with a thoughtful and analytical mindset.
          </p>
        </div>


      ),
    },
    {
      title: 'Think5 Whys Modules',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. Learning:</strong>
            The Learning module is your gateway to a wealth of knowledge. Access various resources, whitepapers,
            videos, and courses designed to enhance critical thinking skills using the Think5Whys framework.
            Elevate your understanding and application of this powerful methodology.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. 5 Whys Analysis:</strong>
            Dive deep into problem-solving with the 5 Whys Analysis module. Uncover the root causes of issues
            and challenges by iteratively asking "why" five times. Empower yourself with a systematic approach
            that fosters critical thinking and effective decision-making.
          </p>

          <p>
            <strong style={{ color: 'black' }}>3. ConnectFive:</strong>
            Think5Whys Connect5 is CRM (Customer Relationship Management) / RMS (Relationship Management System) for MSMEs (Micro, Small, and Medium Enterprises) provides a centralized platform to manage interactions with customers, suppliers, and partners. 
            <br/>
            While RMS (Relationship Management System) is primarily designed for business purposes to manage interactions with customers, suppliers, and partners, its principles can be adapted for personal, family, educational, or friendship settings with some modifications. 
          </p>
          
          <p>
            <strong style={{ color: 'black' }}>4. Life Chronicles:</strong>
            Life Chronicles is your digital journal, capturing moments, experiences, and reflections. Chronicle
            your journey, track achievements, and preserve memories. An introspective tool to enhance
            self-awareness and personal growth.
          </p>

          <p>
            <strong style={{ color: 'black' }}>5. Sigma Studio:</strong>
            ....
          </p>

          <p>
            <strong style={{ color: 'black' }}>6. Sprint Central:</strong>
            ....
          </p>

          <p>
            <strong style={{ color: 'black' }}>7. ApplauseHub:</strong>
            Celebrate achievements and appreciate efforts with ApplauseHub. This module provides a platform
            to acknowledge and reward individuals for their contributions. Cultivate a positive environment
            by recognizing excellence within your team.
          </p>

          <p>
            <strong style={{ color: 'black' }}>8. CommuniCapture:</strong>
            Facilitate seamless communication with CommuniCapture. This module serves as a collaborative space
            for capturing ideas, feedback, and discussions. Foster a culture of open communication, ensuring
            that valuable insights are captured and shared across your team.
          </p>

          <p>
            <strong style={{ color: 'black' }}>9. BPM Jobs & Works:</strong>
            Streamline your hiring and project management processes with the BPM Jobs & Works module. Post and
            apply for jobs, manage projects efficiently, and connect with certified freelancers and BPM consultants.
            Elevate your workforce management to new heights.
          </p>

          <p>
            <strong style={{ color: 'black' }}>10. Profile:</strong>
            The Profile module is your personalized hub within Think5Whys. Manage your account settings, track
            your progress, and showcase your certifications. Your profile is a reflection of your journey and
            accomplishments within the Think5Whys ecosystem.
          </p>
        </div>
      ),
    },
    {
      title: 'Learning',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. EBooks:</strong>
            Immerse yourself in insightful content with a collection of eBooks. Explore in-depth materials covering various
            aspects of critical thinking and the 5 Whys methodology.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. White Papers:</strong>
            Delve into comprehensive White Papers that provide detailed analyses, case studies, and valuable insights related
            to critical thinking, root cause analysis, and effective decision-making.
          </p>

          <p>
            <strong style={{ color: 'black' }}>3. QnA:</strong>
            Engage in a dynamic Question and Answer section. Pose queries, participate in discussions, and gain deeper insights
            by interacting with experts and the Think5Whys community.
          </p>

          <p>
            <strong style={{ color: 'black' }}>4. Videos:</strong>
            Visualize concepts and methodologies through a curated collection of educational videos. Enhance your learning
            experience with engaging visual content that simplifies complex ideas.
          </p>

          <p>
            <strong style={{ color: 'black' }}>5. Templates:</strong>
            Access a repository of practical templates designed to facilitate the application of the 5 Whys methodology.
            Utilize these tools to streamline your problem-solving processes.
          </p>

          <p>
            <strong style={{ color: 'black' }}>6. Workbooks:</strong>
            Enhance your practical skills with interactive workbooks. Apply theoretical knowledge through hands-on exercises
            and real-world scenarios, reinforcing your understanding of critical thinking.
          </p>

          <p>
            <strong style={{ color: 'black' }}>7. Assignments for All:</strong>
            Sharpen your critical thinking skills through assignments tailored for various proficiency levels. These assignments
            cover diverse scenarios and help you apply the 5 Whys methodology effectively.
          </p>

          <p>
            <strong style={{ color: 'black' }}>8. Certification Test:</strong>
            Test your understanding and proficiency by taking the Certification Test. Validate your mastery of critical thinking
            concepts and earn official recognition for your achievements.
          </p>

          <p>
            <strong style={{ color: 'black' }}>9. My Certificate:</strong>
            View and showcase your hard-earned Think5Whys certificates. Keep track of your certifications and share your
            accomplishments with your network.
          </p>

          <p>
            <strong style={{ color: 'black' }}>10. Enroll for Live Workshop:</strong>
            Immerse yourself in a dynamic learning experience by enrolling in live workshops. Interact with experts,
            participate in discussions, and stay updated on the latest developments in critical thinking methodologies.
          </p>
        </div>
      ),
    },
    {
      title: '5 Why Analysis',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. Think5Whys Database:</strong>
            Access a centralized repository that stores and organizes all your 5 Whys analyses. Easily retrieve and review past analyses for continuous improvement.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. My Concerns:</strong>
            Identify and log your concerns within the system. This module allows you to document issues or challenges that need a structured analysis using the 5 Whys methodology.
          </p>

          <p>
            <strong style={{ color: 'black' }}>3. My Objectives:</strong>
            Clearly outline your objectives and goals. Use this feature to align your efforts with your strategic aims and apply the 5 Whys to address challenges hindering goal attainment.
          </p>

          <p>
            <strong style={{ color: 'black' }}>4. Team's Concerns:</strong>
            Collaborate with your team by sharing and collectively addressing concerns. This feature fosters a collaborative approach to problem-solving using the 5 Whys.
          </p>

          <p>
            <strong style={{ color: 'black' }}>5. Team's Objectives:</strong>
            Align team goals and objectives. Utilize this module to collectively set targets and apply the 5 Whys to overcome obstacles hindering team success.
          </p>

          <p>
            <strong style={{ color: 'black' }}>6. Solution Suggestion List:</strong>
            Generate a list of potential solutions. Encourage creativity and innovation by capturing various ideas to address the root causes identified through the 5 Whys.
          </p>

          <p>
            <strong style={{ color: 'black' }}>7. Solution Actions List:</strong>
            Implement and track actions derived from the 5 Whys analysis. This module helps ensure that proposed solutions are systematically executed and monitored for effectiveness.
          </p>

          <p>
            <strong style={{ color: 'black' }}>8. Impact Log:</strong>
            Document the impact of implemented solutions. Track changes, improvements, and overall outcomes resulting from the resolution of identified issues through the 5 Whys.
          </p>

          <p>
            <strong style={{ color: 'black' }}>9. One-View Infographics:</strong>
            Visualize your 5 Whys analyses through intuitive infographics. Gain a comprehensive and easy-to-understand overview of the causal relationships identified.
          </p>

          <p>
            <strong style={{ color: 'black' }}>10. Statistics & Analytics:</strong>
            Leverage statistical insights and analytics derived from 5 Whys analyses. Understand trends, patterns, and recurring issues to make informed decisions and improvements.
          </p>

          <p>
            <strong style={{ color: 'black' }}>11. Fishbones:</strong>
            Create and analyze Fishbone diagrams as part of your 5 Whys process. Visualize the cause-and-effect relationships to identify root causes and drive effective solutions.
          </p>
        </div>

      ),
    },
    {
      title: 'Conenct5',
      description: (
        <div></div>
        // <div>
        //   <p>
        //     <strong style={{ color: 'black' }}>1. My Tasks:</strong>
        //     Organize and manage your daily tasks efficiently. Use this feature to apply the 5 Whys methodology to delve into the root causes of challenges hindering task completion.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>2. My Events:</strong>
        //     Document and reflect on significant events in your life. Apply the 5 Whys to gain insights into the underlying factors influencing the outcomes of these events.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>3. My Memories:</strong>
        //     Chronicle your memories and experiences. Employ the 5 Whys to explore the deeper reasons behind memorable moments and learn valuable lessons.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>4. My Experience:</strong>
        //     Capture and analyze your life experiences. Utilize the 5 Whys to delve into the core reasons behind your experiences, fostering continuous personal growth.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>5. My Invitation:</strong>
        //     Extend and manage invitations with a thoughtful approach. Use the 5 Whys to understand the motivations behind invitations and enhance the overall experience.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>6. My Gratitude:</strong>
        //     Express and reflect on moments of gratitude. Apply the 5 Whys to delve into the reasons behind your feelings of appreciation and cultivate a positive mindset.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>7. My Empathy:</strong>
        //     Develop empathy by understanding the root causes of others' experiences. Use the 5 Whys to explore perspectives and build meaningful connections.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>8. My Sympathy:</strong>
        //     Express sympathy in a thoughtful manner. Apply the 5 Whys to gain insights into the deeper reasons behind feelings of compassion and support.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>9. My Regrets:</strong>
        //     Reflect on and learn from moments of regret. Utilize the 5 Whys to analyze the root causes, enabling personal growth and future decision-making.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>10. My Missed Opportunities:</strong>
        //     Explore missed opportunities and learn from them. Apply the 5 Whys to uncover the underlying reasons for overlooking potential paths.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>11. My Goals:</strong>
        //     Set, analyze, and achieve personal goals. Use the 5 Whys to understand any challenges or obstacles hindering goal attainment.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>12. My Issues:</strong>
        //     Address and resolve personal issues with a structured approach. Apply the 5 Whys to systematically explore the root causes and find effective solutions.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>13. My Visits:</strong>
        //     Record and analyze visits to different places. Employ the 5 Whys to understand the motivations behind visits and enhance future experiences.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>14. Life Resources:</strong>
        //     Access valuable resources to support your life journey. This module provides helpful materials and information related to life and personal development.
        //   </p>

        //   <p>
        //     <strong style={{ color: 'black' }}>15. Definitions:</strong>
        //     Clarify and understand key terms related to life experiences and the 5 Whys methodology. Access a comprehensive glossary for reference.
        //   </p>
        // </div>
      ),
    },    
    {
      title: 'Life Chronicles',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. My Tasks:</strong>
            Organize and manage your daily tasks efficiently. Use this feature to apply the 5 Whys methodology to delve into the root causes of challenges hindering task completion.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. My Events:</strong>
            Document and reflect on significant events in your life. Apply the 5 Whys to gain insights into the underlying factors influencing the outcomes of these events.
          </p>

          <p>
            <strong style={{ color: 'black' }}>3. My Memories:</strong>
            Chronicle your memories and experiences. Employ the 5 Whys to explore the deeper reasons behind memorable moments and learn valuable lessons.
          </p>

          <p>
            <strong style={{ color: 'black' }}>4. My Experience:</strong>
            Capture and analyze your life experiences. Utilize the 5 Whys to delve into the core reasons behind your experiences, fostering continuous personal growth.
          </p>

          <p>
            <strong style={{ color: 'black' }}>5. My Invitation:</strong>
            Extend and manage invitations with a thoughtful approach. Use the 5 Whys to understand the motivations behind invitations and enhance the overall experience.
          </p>

          <p>
            <strong style={{ color: 'black' }}>6. My Gratitude:</strong>
            Express and reflect on moments of gratitude. Apply the 5 Whys to delve into the reasons behind your feelings of appreciation and cultivate a positive mindset.
          </p>

          <p>
            <strong style={{ color: 'black' }}>7. My Empathy:</strong>
            Develop empathy by understanding the root causes of others' experiences. Use the 5 Whys to explore perspectives and build meaningful connections.
          </p>

          <p>
            <strong style={{ color: 'black' }}>8. My Sympathy:</strong>
            Express sympathy in a thoughtful manner. Apply the 5 Whys to gain insights into the deeper reasons behind feelings of compassion and support.
          </p>

          <p>
            <strong style={{ color: 'black' }}>9. My Regrets:</strong>
            Reflect on and learn from moments of regret. Utilize the 5 Whys to analyze the root causes, enabling personal growth and future decision-making.
          </p>

          <p>
            <strong style={{ color: 'black' }}>10. My Missed Opportunities:</strong>
            Explore missed opportunities and learn from them. Apply the 5 Whys to uncover the underlying reasons for overlooking potential paths.
          </p>

          <p>
            <strong style={{ color: 'black' }}>11. My Goals:</strong>
            Set, analyze, and achieve personal goals. Use the 5 Whys to understand any challenges or obstacles hindering goal attainment.
          </p>

          <p>
            <strong style={{ color: 'black' }}>12. My Issues:</strong>
            Address and resolve personal issues with a structured approach. Apply the 5 Whys to systematically explore the root causes and find effective solutions.
          </p>

          <p>
            <strong style={{ color: 'black' }}>13. My Visits:</strong>
            Record and analyze visits to different places. Employ the 5 Whys to understand the motivations behind visits and enhance future experiences.
          </p>

          <p>
            <strong style={{ color: 'black' }}>14. Life Resources:</strong>
            Access valuable resources to support your life journey. This module provides helpful materials and information related to life and personal development.
          </p>

          <p>
            <strong style={{ color: 'black' }}>15. Definitions:</strong>
            Clarify and understand key terms related to life experiences and the 5 Whys methodology. Access a comprehensive glossary for reference.
          </p>
        </div>

      ),
    },
    {
      title: 'Sigma Studio',
      description: (
        <div>
          {/* <p>
            <strong style={{ color: 'black' }}>1. WhatsApp:</strong>
            Seamlessly integrate and capture communication from WhatsApp conversations. This feature allows you to apply the 5 Whys methodology to extract insights from your chat interactions.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. CommuniCapture Help:</strong>
            Access detailed assistance and guidance on effectively utilizing the CommuniCapture module. This help section provides step-by-step instructions, tips, and best practices for optimizing communication capture using the 5 Whys approach.
          </p> */}
        </div>
      ),
    },
    {
      title: 'Sprint Central',
      description: (
        <div>
          {/* <p>
            <strong style={{ color: 'black' }}>1. WhatsApp:</strong>
            Seamlessly integrate and capture communication from WhatsApp conversations. This feature allows you to apply the 5 Whys methodology to extract insights from your chat interactions.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. CommuniCapture Help:</strong>
            Access detailed assistance and guidance on effectively utilizing the CommuniCapture module. This help section provides step-by-step instructions, tips, and best practices for optimizing communication capture using the 5 Whys approach.
          </p> */}
        </div>
      ),
    },
    {
      title: 'Applause Hub',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. Self Applause:</strong>
            Recognize and appreciate your own achievements using the Self Applause feature. Celebrate your successes and accomplishments privately.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. Applause For Me:</strong>
            View and collect applause received from others for your contributions and achievements. This section showcases recognition from your peers.
          </p>

          <p>
            <strong style={{ color: 'black' }}>3. I Applauded:</strong>
            Keep track of the applause you've given to others. Monitor your engagement and encouragement provided to fellow users.
          </p>

          <p>
            <strong style={{ color: 'black' }}>4. My Applause Badges:</strong>
            Access and showcase the badges you've earned through the Applause Hub. Badges signify various achievements and milestones in your journey.
          </p>

          <p>
            <strong style={{ color: 'black' }}>5. My Applause Certificate:</strong>
            Retrieve and display certificates awarded for outstanding performances and contributions acknowledged through the Applause Hub.
          </p>

          <p>
            <strong style={{ color: 'black' }}>6. My Applause Trophy:</strong>
            Showcase the virtual trophy awarded for exceptional accomplishments and consistent positive engagement within the Think5Whys community.
          </p>

          <p>
            <strong style={{ color: 'black' }}>7. My Applause Hub Credits:</strong>
            Manage and track your earned credits within the Applause Hub. Credits can be used for various activities and transactions on the platform.
          </p>

          <p>
            <strong style={{ color: 'black' }}>8. Transfer Applause Hub Credits:</strong>
            Transfer your earned Applause Hub credits to other users, fostering a spirit of collaboration and shared recognition.
          </p>

          <p>
            <strong style={{ color: 'black' }}>9. Applause Leaderboard:</strong>
            Explore the leaderboard to see who's leading in terms of applause and recognition. Celebrate the community's top contributors.
          </p>

          <p>
            <strong style={{ color: 'black' }}>10. My Applause Settings:</strong>
            Customize and manage your settings related to the Applause Hub. Tailor your preferences for a personalized experience.
          </p>

          <p>
            <strong style={{ color: 'black' }}>11. About Applause Hub:</strong>
            Gain insights into the features, functionalities, and purpose of the Applause Hub module. Understand how it enhances user engagement and collaboration.
          </p>
        </div>
      ),
    },
    {
      title: 'CommuniCapture',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. WhatsApp:</strong>
            Seamlessly integrate and capture communication from WhatsApp conversations. This feature allows you to apply the 5 Whys methodology to extract insights from your chat interactions.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. CommuniCapture Help:</strong>
            Access detailed assistance and guidance on effectively utilizing the CommuniCapture module. This help section provides step-by-step instructions, tips, and best practices for optimizing communication capture using the 5 Whys approach.
          </p>
        </div>
      ),
    },
    {
      title: 'BPM Jobs & Works',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. Job Board:</strong>
            Explore and discover a variety of job opportunities related to Business Process Management (BPM) across different industries.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. Seek a Job:</strong>
            Actively search for BPM-related job positions that align with your skills, expertise, and career goals.
          </p>

          <p>
            <strong style={{ color: 'black' }}>3. Post a Job:</strong>
            Employers can post job listings for BPM roles, connecting with potential candidates interested in contributing to their projects.
          </p>

          <p>
            <strong style={{ color: 'black' }}>4. Instant Jobs:</strong>
            Access quick and immediate job opportunities in the BPM field, offering rapid employment options for both job seekers and employers.
          </p>

          <p>
            <strong style={{ color: 'black' }}>5. Instant Interaction:</strong>
            Facilitate real-time communication between job seekers and employers, enabling instant interaction for swift collaboration.
          </p>

          <p>
            <strong style={{ color: 'black' }}>6. Feedbacks & Ratings:</strong>
            Provide and receive feedback and ratings for job performances, fostering transparency and accountability in the BPM community.
          </p>

          <p>
            <strong style={{ color: 'black' }}>7. Verified Recruiters:</strong>
            Connect with recruiters who have undergone verification, ensuring a trustworthy and reliable recruitment process.
          </p>

          <p>
            <strong style={{ color: 'black' }}>8. Certified Freelancers:</strong>
            Engage with certified freelancers specializing in BPM services, offering a pool of skilled professionals for various projects.
          </p>

          <p>
            <strong style={{ color: 'black' }}>9. Job Work Diary:</strong>
            Maintain a comprehensive diary recording job-related activities, achievements, and progress in the BPM domain.
          </p>

          <p>
            <strong style={{ color: 'black' }}>10. Time Tracker:</strong>
            Effectively manage and track the time spent on BPM-related tasks, ensuring accurate billing and efficient project management.
          </p>

          <p>
            <strong style={{ color: 'black' }}>11. BPM Consultants:</strong>
            Access a network of BPM consultants providing expert guidance and support for strategic business process improvement.
          </p>

          <p>
            <strong style={{ color: 'black' }}>12. Experts Services:</strong>
            Explore specialized services offered by BPM experts, ranging from consultancy to tailored solutions for unique business challenges.
          </p>

          <p>
            <strong style={{ color: 'black' }}>13. Intern Positions:</strong>
            Discover internship opportunities in the BPM sector, allowing individuals to gain valuable hands-on experience and contribute to projects.
          </p>

          <p>
            <strong style={{ color: 'black' }}>14. Retail Positions:</strong>
            Explore job positions specifically tailored for the retail sector within the broader BPM framework.
          </p>

          <p>
            <strong style={{ color: 'black' }}>15. SME Support:</strong>
            Access support services specifically designed for Small and Medium Enterprises (SMEs) operating in the BPM landscape.
          </p>

          <p>
            <strong style={{ color: 'black' }}>16. Job Payments:</strong>
            Manage and process payments related to BPM jobs efficiently and securely through the platform.
          </p>

          <p>
            <strong style={{ color: 'black' }}>17. Job Payment Protection:</strong>
            Ensure the protection of job-related payments, providing a secure environment for financial transactions.
          </p>

          <p>
            <strong style={{ color: 'black' }}>18. About Think5Whys BPM Jobs:</strong>
            Gain insights into the purpose, features, and functionalities of the BPM Jobs & Works module, understanding its role in facilitating job interactions and opportunities within the BPM community.
          </p>
        </div>
      ),
    },
    {
      title: 'Profile',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. My Profile:</strong>
            Manage and update your personal information, including details such as name, contact information, and professional bio.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. My Extended Profile:</strong>
            Provide additional details and context about your professional background, achievements, and skills for a comprehensive profile.
          </p>

          <p>
            <strong style={{ color: 'black' }}>3. Change Password:</strong>
            Ensure the security of your account by updating and managing your password securely.
          </p>

          <p>
            <strong style={{ color: 'black' }}>4. My White List:</strong>
            Curate a list of trusted contacts or entities, streamlining communication and collaboration within the Think5Whys platform.
          </p>

          <p>
            <strong style={{ color: 'black' }}>5. My Team Hierarchy:</strong>
            Visualize and manage the hierarchy of your team, showcasing the structure and roles within your professional network.
          </p>

          <p>
            <strong style={{ color: 'black' }}>6. My Subscription:</strong>
            Monitor and manage your subscription plan, ensuring access to the desired features and functionalities within the Think5Whys platform.
          </p>

          <p>
            <strong style={{ color: 'black' }}>7. My Wallet:</strong>
            Keep track of financial transactions, payments, and credits associated with your account and platform usage.
          </p>

          <p>
            <strong style={{ color: 'black' }}>8. My Settings:</strong>
            Customize and configure platform settings according to your preferences, optimizing your user experience.
          </p>

          <p>
            <strong style={{ color: 'black' }}>9. Think5Whys Pricing:</strong>
            Access information about the pricing structure of Think5Whys services and subscription plans.
          </p>

          <p>
            <strong style={{ color: 'black' }}>10. Think5Whys Help:</strong>
            Find resources, guides, and support to navigate through the Think5Whys platform effectively, ensuring a smooth user experience and addressing any queries or concerns.
          </p>
        </div>

      ),
    },
    {
      title: 'Technology',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. Dynamic and Responsive Interface:</strong>
            Our platform ensures a dynamic and responsive user interface, allowing users to engage effortlessly with features and content on various devices.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. Real-time Collaboration:</strong>
            Enabling real-time collaboration, Think5Whys fosters instant updates and interactive discussions among users, enhancing the overall collaborative experience.
          </p>

          <p>
            <strong style={{ color: 'black' }}>3. Scalability for Growing Needs:</strong>
            Think5Whys offers scalability to accommodate growing datasets and user bases, ensuring a smooth and uninterrupted user experience as the platform expands.
          </p>

          <p>
            <strong style={{ color: 'black' }}>4. Unified Development Language:</strong>
            Utilizing a unified development language for seamless communication between frontend and backend components ensures a cohesive and streamlined development process.
          </p>

          <p>
            <strong style={{ color: 'black' }}>5. Secure User Data Handling:</strong>
            Robust security features ensure the protection of user data, establishing a secure environment for users to engage in critical thinking and collaborative activities.
          </p>

          <p>
            <strong style={{ color: 'black' }}>6. Efficient Performance:</strong>
            Think5Whys delivers swift response times and seamless interactions, providing users with a fluid and enjoyable platform experience.
          </p>

          <p>
            <strong style={{ color: 'black' }}>7. Adaptable to Evolving Needs:</strong>
            The platform can quickly adapt to evolving requirements, allowing for easy updates, modifications, and the introduction of new features to meet users' changing needs.
          </p>

          <p>
            <strong style={{ color: 'black' }}>8. Community-Backed Innovation:</strong>
            Think5Whys aligns with a vibrant and supportive developer community, ensuring constant innovation, regular updates, and access to a wealth of resources to enhance the user experience.
          </p>

          <p>
            By choosing Think5Whys, users can experience a platform that not only fosters critical thinking but also provides a technologically advanced, secure, and user-friendly environment, empowering them in their journey towards deep thinking and collaborative problem-solving.
          </p>
        </div>

      ),
    },
    {
      title: 'White Labels & Customisation',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>Elevate your institutional experience with Think5Whys</strong>
            Elevate your institutional experience with Think5Whys' White Label and Customization services.
            Harness the power of deep thinking and critical analysis uniquely tailored to your organization's branding and specific needs. Our commitment to best practices ensures a seamless integration, offering corporates and government entities an intuitive and personalized platform that aligns effortlessly with their identity and objectives.
          </p>
        </div>

      ),
    },
  ];

  const [expandedTopic, setExpandedTopic] = useState(null);

  const handleTopicClick = (index) => {
    setExpandedTopic(expandedTopic === index ? null : index);
  };

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Think5Whys Help Center</h2>
      </div>
      <div className="help-container">
        <ul className="help-list">
          {topics.map((topic, index) => (
            <li key={index} onClick={() => handleTopicClick(index)} className="help-topic">
              {topic.title}
              {expandedTopic === index && (
                <div className="help-description">
                  <p>{topic.description}</p>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </MainLayout>
  );
};

export default AboutThink5WhysPlatform;


